import axios from "axios";

function searchUser(email) {
  return new Promise((resolve, reject) => {

    try {
      let port = ""
      if (process.env.ROOT_API.includes("viewmedonline"))
        port = ":3018"
      axios
        .get(process.env.ROOT_API + "/users/exists/" + email)
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error.response);
        });
    } catch (err) {
      console.log("err in searchUser: ", err);
    }
  });
}

function codeRegister(objCode, type) {
  return new Promise((resolve, reject) => {
    try {
      let port = ""
      let aux = {
        forename: objCode.forename,
        surname: objCode.surname,
        email: objCode.email,
        role: objCode.role,
        passwd: objCode.passwd,
        language: objCode.language,
        domain: objCode.domain,
        institution_id:objCode.institution_id
      }
      if (type == 'Physician') {
        aux.category = objCode.category
      }
      if (type == 'Institution') {
        aux.typeOfInstitution = objCode.category
      }
      if (process.env.ROOT_API.includes("viewmedonline"))
        port = ":3036"
      axios
        .post(process.env.ROOT_API + "/code_register", aux)
        .then(result => {
          resolve(result.data.documents)
        })
    } catch (err) {
      console.log("err in codeRegister: ", err);
    }
  })
}

function listType(obj) {
  return new Promise((resolve, reject) => {

    try {
      let port = ""
      if (process.env.ROOT_API.includes("viewmedonline"))
        port = ":3018"
      axios
        .get(process.env.ROOT_API + "/tenant/category/" + obj.type)
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response);
        });
    } catch (err) {
      console.log("err in searchType: ", err);
    }
  });
}
function insert_pg(objAux) {
  return new Promise((resolve, reject) => {
    axios.post(process.env.ROOT_API + "/pg/client/insert", objAux.body, {
      headers: {
        "Authorization": objAux.token
      }
    }).then(result => {
      resolve(result.data.documents)
    }).catch(error => {
      reject(error)
    })
  })
}

function register_physician(objAux) {
  return new Promise((resolve, reject) => {
    axios.post(process.env.ROOT_API + "/physician_register", objAux.body, {
      headers: {
        "Authorization": sessionStorage.getItem("pussy")
      }
    }).then(result => {
      resolve(result.data.documents);
    }).catch(error => {
      reject(error)
    })
  })
}


export {
  searchUser,
  codeRegister,
  listType,
  insert_pg,
  register_physician
}



// WEBPACK FOOTER //
// ./src/components/register/registerSer.js